import React, { Component } from 'react';
import { Select } from "antd";
import { inject, observer } from "mobx-react";
import Actual from "./Actual";
import Forecast from "./Forecast";
import Budget from "./Budget";
import "./index.scss";

const Option = Select.Option;

@inject('store')
@observer
class index extends Component {
    state = {
        dateData: []
    }

    componentDidMount() {
        let date = Number(this.props.store.effectActual.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });

        this.props.store.effectActual.getData();
    }

    render() {
        const { date, onChangeDate } = this.props.store.effectActual;
        return (
            <div className="performanceReview effect">
                <div className="first-title">
                    <div> 1.1 Efficiency Per Square Meter Analysis 酒店坪效经营情况分析</div>
                    <div className="table-month">
                        <Select
                            placeholder="请选择年份"
                            style={{ width: 120 }}
                            value={date}
                            onChange={(str) => {
                                onChangeDate(str);
                            }}
                        >
                            {this.state.dateData.map((x, i) => {
                                return (
                                    <Option value={x} key={x}>{x}年</Option>
                                )
                            })}
                        </Select>
                    </div>
                </div>

                <Forecast />
                <Budget />
                <Actual />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/effect/index.js